module.exports = __webpack_public_path__ + "img/8283c4d788bd0e47afa1a47910d3166b.png";